<template>
  <div class="breadcrumbs">
    <nav class="breadcrumbs__trail">
      <span>Inicio</span>
      <i class="fas fa-chevron-right breadcrumbs__sep"></i>
      <span class="breadcrumbs__current">{{ currentPage }}</span>
    </nav>
    <h1 class="breadcrumbs__title">{{ currentPage }}</h1>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumbs',
  props: {
    currentPage: { required: true },
    textWhite: { type: String, default: '' },
  },
}
</script>

<style scoped>
.breadcrumbs__trail {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  color: #94A3B8;
  margin-bottom: 1px;
}

.breadcrumbs__sep {
  font-size: 0.55rem;
}

.breadcrumbs__current {
  color: #64748B;
}

.breadcrumbs__title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1E293B;
  margin: 0;
  line-height: 1.2;
}
</style>
